export var QuestionJustifyContent;
(function (QuestionJustifyContent) {
    QuestionJustifyContent["Start"] = "start";
    QuestionJustifyContent["Center"] = "center";
    QuestionJustifyContent["End"] = "end";
})(QuestionJustifyContent || (QuestionJustifyContent = {}));
//# sourceMappingURL=question-page.types.js.map